import { Component, h, Host, Prop, State, Element, Method } from '@stencil/core';
import axios from '../../../utils/get-axios';

const ACC = (window as any).ACC;

@Component({
  tag: 'lilu-add-to-cart-wrapper',
  styleUrl: 'lilu-add-to-cart-wrapper.scss',
  shadow: true,
})
export class LiluAddToCartWrapper {
  @Prop() selection: 'pickup' | 'delivery' | '' = '';
  @Prop() productId: string = '';
  @Prop() dropdownCount: number = 10;
  @Prop() buttonText: string = '';
  @Prop() modalAxiosUrl: string;
  @Prop() basketAxiosUrl: string;
  @Prop() changeStoreAxiosUrl: string;
  @Prop() hiddenInputsModal: string;
  @Prop() inputJSON: any;
  @Prop() isWishlist: boolean = false;
  @Prop() basket: any;
  @Prop() appearance = 'default';
  @Prop() placeholder = '';

  @Prop() min = '10';
  @Prop() max = '1000';
  @Prop() step = '10';

  @State() dropdownShow: boolean = false;
  @State() value: string = '1';
  @Element() el: HTMLElement;

  private modal: any;
  private modalContent: any;

  @Method()
  async getProductId() {
    return this.productId;
  }

  @Method()
  async updatePickUp(data) {
    const allPickupElements = this.el.querySelectorAll('*[slot="pickup"]');
    allPickupElements.forEach(element => {
      element.remove();
    });

    const pickUpDiv = document.createElement('div');
    pickUpDiv.setAttribute('slot', 'pickup');
    pickUpDiv.setAttribute('class', 'pickup-container');
    pickUpDiv.innerHTML = data.addToBasketNew;
    this.el.appendChild(pickUpDiv);
  }

  private isDisabled(slotName: string): boolean {
    return this.el.querySelector(`lilu-add-to-cart-tile[slot='${slotName}']`).classList.contains('disabled');
  }

  private activateSlot(slotName: string) {
    this.el.querySelectorAll('lilu-add-to-cart-tile').forEach(element => {
      element.classList.remove('active');
    });

    this.el.querySelector(`lilu-add-to-cart-tile[slot=${slotName}]`).classList.add('active');
  }

  private selectionChange(e, pickupOrDelivery) {
    if (this.isDisabled(pickupOrDelivery)) return;

    this.activateSlot(pickupOrDelivery);
    this.selection = pickupOrDelivery;

    const closestCartCard = e.target.closest('lilu-add-to-cart-tile') as any as HTMLElement;
    if (!closestCartCard) return;
    const closestCartCardStoreId = closestCartCard.getAttribute('store-id');
    if (closestCartCardStoreId === null || closestCartCardStoreId === '') {
      this.openModal(this.modalAxiosUrl);
    }
  }

  private openModal(url) {
    if (this.modalContent !== null) {
      this.modalContent.innerHTML = '';
    }

    if (url !== undefined && url !== '') {
      let data: any = {};

      this.inputJSON.inputs.forEach(input => {
        const name = input.name;
        const value = input.value;

        data[name] = value;
      });
      axios
        .post(url, data, {
          headers: {
            CSRFToken: ACC.config.CSRFToken,
          },
        })
        .then(response => {
          if (response.data.content === undefined) {
            this.modalContent.innerHTML = response.data.html;
          } else {
            this.modalContent.innerHTML = response.data.content;
          }
          const isLogin = this.modalContent.innerHTML.indexOf('lilu-login') >= 0;
          this.modal.open(this.productId, true, isLogin);
        });
    }
  }

  componentWillLoad() {
    this.inputJSON = JSON.parse(this.hiddenInputsModal);
    this.modal = document.querySelector(`[data-modal="default"]`);
    this.modalContent = document.querySelector(`[data-modal="default"] .content`);
    this.basket = document.querySelector(`lilu-mini-basket`);
  }

  componentDidLoad() {
    this.value = this.getQuantity();
  }

  private getQuantity() {
    const amountField = this.el.shadowRoot.querySelector('lilu-dropdown') as HTMLLiluDropdownElement | null;
    const input = this.el.shadowRoot.querySelector('#chf-amount') as HTMLInputElement | null;

    return amountField ? amountField.value : input?.value || '';
  }

  private getProductIDAndQuantity() {
    if (this.appearance === 'giftcard') {
      return `${this.productId}-1-${this.getQuantity()}`;
    } else {
      return `${this.productId}-${this.getQuantity()}`;
    }
  }

  private getActiveStoreID() {
    const activeStoreId = this.el.querySelector('lilu-add-to-cart-tile.active[store-id]')?.getAttribute('store-id');
    if (activeStoreId && activeStoreId.length > 0) {
      return activeStoreId;
    } else {
      return null;
    }
  }

  addProductToBasketSuccessHandler = _ => {};

  errorHandler = error => {
    console.error(`Error while adding item to basket: ${error}`);
  };

  @Method()
  async addToBasket(storeId: string = null) {
    if (this.selection === 'pickup') {
      if (storeId) {
        this.basket.addProductToBasket(this.basketAxiosUrl, this.getProductIDAndQuantity(), storeId, this.addProductToBasketSuccessHandler, this.errorHandler);
      } else {
        this.openModal(this.modalAxiosUrl);
      }
    } else {
      this.basket.addProductToBasket(this.basketAxiosUrl, this.getProductIDAndQuantity(), '', this.addProductToBasketSuccessHandler, this.errorHandler);
    }
  }

  private validateGiftCardAmount(event: FocusEvent) {
    const field = event.target as HTMLInputElement;
    try {
      const amount = Number(field.value);
      // if the number is out of the range of this.min and this.max, set up the min or the max.
      const clampedValue = Math.min(Math.max(amount, Number(this.min)), Number(this.max));
      // round to the closest step
      const roundedValue = Math.round(clampedValue / Number(this.step)) * Number(this.step);

      field.value = roundedValue.toString();
    } catch (_err) {
      field.value = this.min;
    }
  }

  private renderDefault() {
    return (
      <Host>
        {this.getActiveStoreID() ? (
          <div class={`link`} onClick={() => this.openModal(this.changeStoreAxiosUrl)}>
            <slot name={`link`} />
          </div>
        ) : (
          ''
        )}
        <div class={`selection`}>
          <div class={`pickup`} onClick={e => this.selectionChange(e, 'pickup')}>
            <input type={`radio`} name={`options`} checked={this.selection === 'pickup'} />
            <slot name={`pickup`} />
          </div>
          <div class={`delivery`} onClick={e => this.selectionChange(e, 'delivery')}>
            <input type={`radio`} name={`options`} checked={this.selection === 'delivery'} />
            <slot name={`delivery`} />
          </div>
        </div>
        <div class={`action`}>
          <lilu-dropdown type="number" onValueChange={e => (this.value = e.detail.value)}></lilu-dropdown>

          <lilu-button onClick={() => this.addToBasket(this.getActiveStoreID())} type="primary" height="h-lg" width="w-full-width" font="semibold" fontsize="size-14">
            {this.buttonText}
          </lilu-button>
          <div class={`wishlist`}>
            <lilu-wishlist is-wishlist={this.isWishlist} size="size-md" product-id={this.productId}></lilu-wishlist>
          </div>
        </div>
      </Host>
    );
  }

  private renderGiftCardForm() {
    return (
      <Host>
        <div class="giftcard-form">
          <div class="amount">
            <label htmlFor="amount">CHF</label>
            <input
              type="number"
              placeholder={this.placeholder}
              step={this.step}
              min={this.min}
              max={this.max}
              name="chf-amount"
              id="chf-amount"
              class="input"
              onBlur={event => {
                this.validateGiftCardAmount(event);
              }}
            />
          </div>
          <lilu-button
            onClick={() => this.addToBasket(this.getActiveStoreID())}
            type="primary"
            height="h-lg"
            width="w-full-width"
            transform="none"
            font="semibold"
            fontsize="size-14"
          >
            {this.buttonText}
          </lilu-button>
        </div>
      </Host>
    );
  }

  render() {
    switch (this.appearance) {
      case 'giftcard':
        return this.renderGiftCardForm();

      default:
        return this.renderDefault();
    }
  }
}
